<template>
  <v-dialog
    v-model="showdialog5"
    width="600px"
    v-if="this.moduleItem5.has_download != 0"
  >
    <v-card class="overflow-hidden">
      <v-toolbar dark class="primary">
        <v-toolbar-items>
          <v-card-title class="titcss white--text"
            >Dowloader Access List</v-card-title
          >
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-btn class="" text dark @click="close_dialog()">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-row class="my-3 mx-2">
        <v-data-table :headers="headers" dense :items="downloaderdata">
          <template v-slot:[`item.mobileno`]="{ item }">
            <span class="caption" v-if="item.mobileno != null"
              >+60 {{ item.mobileno }}</span
            >
            <span class="caption" v-if="item.mobileno == null">-</span>
          </template>
        </v-data-table>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  props: {
    moduleItem5: Object,
    showdialog5: Boolean,
  },
  data: () => ({
    headers: [
      { text: "NAME", value: "name", sortable: false },
      { text: "CONTACT NUMBER", value: "mobileno", sortable: false },
      { text: "EMAIL", value: "emailid", sortable: false },
    ],
    downloaderdata: [],
  }),
  watch: {
    showdialog5(val) {
      if (val == true) {
        // console.log("Item value recieving", this.moduleItem5);
        this.getmakers();
      }
    },
  },
  methods: {
    close_dialog() {
      this.$emit("closeDialog5");
    },
    async getmakers() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETUSERLIST",
          module_id: this.moduleItem5.moduleid,
          type: "6",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("responseData", responseData);
      this.downloaderdata =
        responseData.data.data != null || responseData.data.data != undefined
          ? responseData.data.data
          : [];
    },
  },
};
</script>

<style></style>
